const CONFIG_KEYS = [
  "REACT_APP_GRAPHQL_URI",
  "REACT_APP_MSAL_REDIRECT_URI",
  "REACT_APP_CLIENT_ID",
  "REACT_APP_ACTIVE_REPORT_LICENSE_KEY",
  "REACT_APP_BUILD_ID",
  "REACT_APP_BUILD_TIME",
  "REACT_APP_SENTRY_ENV",
];

export const getConfig = (key, defaultValue) => {
  const runtimeValue =
    typeof window !== "undefined" ? window.__APP_CONFIG__?.[key] : undefined;

  return runtimeValue || defaultValue;
};

export const getPublicConfig = () =>
  CONFIG_KEYS.reduce(
    (config, key) => ({
      ...config,
      [key]: getConfig(key),
    }),
    {},
  );

export const getAppEnvironment = () => getConfig("REACT_APP_SENTRY_ENV", "dev");

export const isDevelopmentEnvironment = () =>
  ["dev", "development", "local"].includes(getAppEnvironment());

const ENVIRONMENT_BRANDING = {
  local: {
    badgeClassName: "bg-yellow-400",
    badgeLabel: "LOCAL",
    faviconColor: "#facc15",
    mastheadClassName: "bg-yellow-400",
  },
  dev: {
    badgeClassName: "bg-blue-500 text-white",
    badgeLabel: "DEV",
    faviconColor: "#3b82f6",
    mastheadClassName: "bg-blue-500",
  },
  preprod: {
    badgeClassName: "bg-red-500 text-black",
    badgeLabel: "PREPROD",
    faviconColor: "#ef4444",
    mastheadClassName: "bg-red-500",
  },
  production: {
    badgeClassName: "",
    badgeLabel: "",
    faviconColor: "#000000",
    mastheadClassName: "bg-white",
  },
};

export const getEnvironmentBranding = ({
  environment = getAppEnvironment(),
  graphqlUri = getConfig("REACT_APP_GRAPHQL_URI", ""),
} = {}) => {
  const normalizedEnvironment = environment.toLowerCase();
  const normalizedGraphqlUri = graphqlUri.toLowerCase();
  const isLocal =
    normalizedEnvironment === "local" ||
    normalizedGraphqlUri.includes("localhost");
  const isPreprod =
    ["preprod", "staging"].includes(normalizedEnvironment) ||
    normalizedGraphqlUri.includes("preprod");
  const isDev =
    !isLocal &&
    !isPreprod &&
    (["dev", "development"].includes(normalizedEnvironment) ||
      normalizedGraphqlUri.includes("dev"));
  const name = isLocal
    ? "local"
    : isPreprod
      ? "preprod"
      : isDev
        ? "dev"
        : "production";

  return {
    ...ENVIRONMENT_BRANDING[name],
    isNonProduction: name !== "production",
    name,
  };
};
